import permission from '../../../helpers/permission';
import { hasPlanFeature } from '../../../helpers/platformFeature';

export const PRENATAL_PLAN_FEATURE = 'prontuario.prenatal';

export function prenatalAvailable() {
  return hasPlanFeature(PRENATAL_PLAN_FEATURE) && permission.has('List Prenatal');
}

export function canStorePrenatal() {
  return prenatalAvailable() && permission.has('Store Prenatal');
}

export function canUpdatePrenatal() {
  return prenatalAvailable() && permission.has('Update Prenatal');
}

export function canDeletePrenatal() {
  return prenatalAvailable() && permission.has('Delete Prenatal');
}
